import ComponentTitle from "../ComponentTitle";
import PortfolioCard from "./PortfolioCard";
import {Link} from "react-router-dom";

const Portfolio = ({portfolios}) => {
    
    const portfolioReturn = () => {
        const results = [];
        for (let i = 0; i < 3; i++) {
            results.push(<PortfolioCard 
                id={portfolios[i].id}
                description={portfolios[i].description}
                title={portfolios[i].title}
                tags={portfolios[i].tags}
                imageBackground={portfolios[i].imgBackground}
            />)
        }
        return results
        // console.log(portfolios)
    }
    
    return(
        <section id={"portfolio"} className={'py-16 bg-white dark:bg-slate-800 transition-colors duration-300 flex flex-col justify-center w-full items-center relative'}>
            {/* Subtle separator line top */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent"></div>
            
            <ComponentTitle title={'Portfolio'} />
            <div className={'flex flex-col lg:flex-row gap-5 items-center justify-center px-10 mt-8'}>
                {portfolios?.map((data) => (
                    <PortfolioCard
                        key={data.id}
                        id={data.id}
                        description={data.description}
                        title={data.title}
                        tags={data.portfolioTechs}
                        imageBackground={data.photoUrl}
                    />
                ))}
            </div>
            <div className={'mt-16 text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors duration-300 font-medium'}>
                <Link onClick={() => window.scrollTo(0,0)} to={'/portfolios'}>Show More ...</Link>
            </div>
        </section>
    )
}
export default Portfolio;